import logoUrl from "@/assets/ivp-logo.png";

export const IvpLogo = ({ className = "" }) => {
  return (
    <div className={className} data-testid="ivp-logo">
      <img
        src={logoUrl}
        alt="IVP — Impeccable Vintage Properties"
        className="h-16 w-auto object-contain sm:h-20"
      />
    </div>
  );
};
